'use client';

import { usePathname } from 'next/navigation';
import DynamicJsonLd from './dynamic-json-ld';

export default function AboutSeo() {
  const pathname = usePathname();

  // For about page, we'll include the organization schema
  return <DynamicJsonLd type='organization' pathname={pathname} />;
}
